import { takeLatest, call, put, cancel } from "redux-saga/effects";
import { fetchEntity } from "./apiSagas.js";

import { createEntityCall } from "../../services/api.js";
import { createAction } from "../actions/actionUtils.js";

import { VERIFY } from "../actions/actionConstants.js";

export function* verifySaga(action) {
  // using fetchEntity as slightly different error handling than the standard
  try {
    yield call(fetchEntity, createEntityCall, VERIFY, undefined, action);
    yield put(createAction(VERIFY.POST_COMPLETE));
  } catch (error) {
    if (error.status !== 400 && error.status !== 422) {
      yield cancel();
    }
    // but what happens with a 400 or 422?
  }
}

// -- WATCHERS -- //

export function* watchVerifySagas() {
  yield takeLatest(VERIFY.POST, verifySaga);
}
